import {
  CompanyName,
  FULL_BUSINESS_URL,
} from '../Constants';


// About Me Page Meta and Structured Data
export const aboutMePageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'Person',
  name: 'Mistress Sammi TS',
  url: `${FULL_BUSINESS_URL}/about-me`,
  image: `${FULL_BUSINESS_URL}/images/mistress-sammi.jpg`,
  description:
    'Discover more about Mistress Sammi TS, a professional dominatrix offering immersive BDSM experiences with a focus on connection, trust, and passion.',
  jobTitle: 'Professional Dominatrix',
  worksFor: {
    '@type': 'Organization',
    name: `${CompanyName}`,
    url: `${FULL_BUSINESS_URL}`,
  },
  sameAs: ['SOCIAL_MEDIA_LINK_1', 'SOCIAL_MEDIA_LINK_2', 'SOCIAL_MEDIA_LINK_3'],
  knowsAbout: [
    'BDSM',
    'Dominance and Submission',
    'Fetish Exploration',
    'Roleplay Scenarios',
    'Discipline and Training',
  ],
};

export const aboutMePageAdditionalMeta = [
  { property: 'og:title', content: 'About Mistress Sammi TS' },
  {
    property: 'og:description',
    content:
      'Learn more about Mistress Sammi TS, a professional dominatrix specializing in immersive, passionate, and unique BDSM experiences.',
  },
  {
    property: 'og:image',
    content: `${FULL_BUSINESS_URL}/images/mistress-sammi.jpg`,
  },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/about-me` },
  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: 'About Mistress Sammi TS' },
  {
    name: 'twitter:description',
    content:
      'Discover the world of Mistress Sammi TS, a dominatrix dedicated to real connection, trust, and the art of domination.',
  },
  {
    name: 'twitter:image',
    content: `${FULL_BUSINESS_URL}/images/mistress-sammi.jpg`,
  },
];


// Testimonials
export const testimonialsPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: `Testimonials - ${CompanyName}`,
  url: `${FULL_BUSINESS_URL}/testimonials`,
  description: `Explore genuine testimonials from those who have submitted to ${CompanyName}, a fierce and commanding trans dominatrix. Read about their unforgettable experiences and devotion.`,
  mainEntity: {
    '@type': 'Organization',
    name: 'Mistress Sammi Smith',
    url: FULL_BUSINESS_URL,
    logo: {
      '@type': 'ImageObject',
      url: `${FULL_BUSINESS_URL}/brand/logo.png`,
    },
  },
};

export const testimonialsPageAdditionalMeta = [
  {
    property: 'og:title',
    content: `Testimonials - Submission to ${CompanyName}`,
  },
  {
    property: 'og:description',
    content: `Read real experiences from those who have surrendered to ${CompanyName}, a powerful trans dominatrix. Witness their devotion and unforgettable encounters.`,
  },
  {
    property: 'og:image',
    content: `${FULL_BUSINESS_URL}/brand/testimonials-preview.jpg`,
  },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/testimonials` },
  { name: 'twitter:card', content: 'summary_large_image' },
  {
    name: 'twitter:title',
    content: `Testimonials - Submission to Mistress Sammi Smith`,
  },
  {
    name: 'twitter:description',
    content: `Discover authentic testimonials from those who have submitted to Mistress Sammi Smith. Their words reflect devotion, discipline, and unforgettable experiences.`,
  },
  {
    name: 'twitter:image',
    content: `${FULL_BUSINESS_URL}/brand/testimonials-preview.jpg`,
  },
];

export const ApplicationPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: `${CompanyName} - Session Questionnaire`,
  url: `${FULL_BUSINESS_URL}/questionnaire`,
  description: `Complete Mistress Sammi's exclusive session questionnaire to tailor your perfect BDSM experience.`,
  inLanguage: 'en',
  breadcrumb: {
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Home',
        item: FULL_BUSINESS_URL,
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: 'Questionnaire',
        item: `${FULL_BUSINESS_URL}/questionnaire`,
      },
    ],
  },
  author: {
    '@type': 'Person',
    name: CompanyName,
    url: FULL_BUSINESS_URL,
  },
  publisher: {
    '@type': 'Organization',
    name: CompanyName,
    logo: {
      '@type': 'ImageObject',
      url: `${FULL_BUSINESS_URL}/brand/logo.png`,
    },
  },
};

export const ApplicationPageAdditionalMeta = [
  { property: 'og:title', content: `Session Questionnaire | ${CompanyName}` },
  {
    property: 'og:description',
    content: `Customize your experience with Mistress Sammi TS by filling out this detailed BDSM session questionnaire.`,
  },
  { property: 'og:image', content: `${FULL_BUSINESS_URL}/brand/logo.png` },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/questionnaire` },
  { name: 'twitter:card', content: 'summary_large_image' },
  {
    name: 'twitter:title',
    content: `Session Questionnaire | ${CompanyName}`,
  },
  {
    name: 'twitter:description',
    content: `Submit your preferences and desires to create a tailored experience with Mistress Sammi TS.`,
  },
  { name: 'twitter:image', content: `${FULL_BUSINESS_URL}/brand/logo.png` },
];

// Services Page Meta and Structured Data
export const servicesPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'Person',
  name: `${CompanyName}`,
  url: `${FULL_BUSINESS_URL}/services`,
  image: `${FULL_BUSINESS_URL}/images/mistress-sammi.jpg`,
  description:
    `Discover more about ${CompanyName}, a professional dominatrix offering immersive BDSM experiences with a focus on connection, trust, and passion.`,
  jobTitle: 'Professional Dominatrix',
  worksFor: {
    '@type': 'Organization',
    name: `${CompanyName}`,
    url: `${FULL_BUSINESS_URL}`,
  },
  sameAs: ['SOCIAL_MEDIA_LINK_1', 'SOCIAL_MEDIA_LINK_2', 'SOCIAL_MEDIA_LINK_3'],
  knowsAbout: [
    'BDSM',
    'Dominance and Submission',
    'Fetish Exploration',
    'Roleplay Scenarios',
    'Discipline and Training',
  ],
};

export const servicesPageAdditionalMeta = [
  { property: 'og:title', content: `About ${CompanyName}` },
  {
    property: 'og:description',
    content:
      `Learn more about ${CompanyName}, a professional dominatrix specializing in immersive, passionate, and unique BDSM experiences.`,
  },
  {
    property: 'og:image',
    content: `${FULL_BUSINESS_URL}/images/mistress-sammi.jpg`,
  },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/services` },
  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: `About ${CompanyName}` },
  {
    name: 'twitter:description',
    content:
      `Discover the world of ${CompanyName}, a dominatrix dedicated to real connection, trust, and the art of domination.`,
  },
  {
    name: 'twitter:image',
    content: `${FULL_BUSINESS_URL}/images/mistress-sammi.jpg`,
  },
];


// Clips & Fansites Page
// Clips & Fansites Page
export const clipsAndFansitesStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: `Clips & Fansites - ${CompanyName}`,
  url: `${FULL_BUSINESS_URL}/clips-and-fansites`,
  description:
    `Explore ${CompanyName}’s exclusive BDSM and Femdom video content, including intense domination clips and fetish-themed sessions.`,
  publisher: {
    '@type': 'Organization',
    name: CompanyName,
    url: FULL_BUSINESS_URL,
    logo: {
      '@type': 'ImageObject',
      url: `${FULL_BUSINESS_URL}/brand/logo.png`,
    },
  },
  potentialAction: {
    '@type': 'ViewAction',
    target: `${FULL_BUSINESS_URL}/clips-and-fansites`,
  },
};

export const clipsAndFansitesAdditionalMeta = [
  {
    property: 'og:title',
    content: `Clips & Fansites - ${CompanyName}`,
  },
  {
    property: 'og:description',
    content:
      `Watch exclusive BDSM and Femdom videos from ${CompanyName}. Explore domination clips, fetish content, and erotic hypnosis.`,
  },
  {
    property: 'og:image',
    content: `${FULL_BUSINESS_URL}/assets/images/clips-banner.jpg`,
  },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/clips-and-fansites` },
  { name: 'twitter:card', content: 'summary_large_image' },
  {
    name: 'twitter:title',
    content: `Clips & Fansites - ${CompanyName}`,
  },
  {
    name: 'twitter:description',
    content:
      `Discover a world of exclusive Femdom and BDSM video content by ${CompanyName}. Subscribe now for intense domination clips.`,
  },
  {
    name: 'twitter:image',
    content: `${FULL_BUSINESS_URL}/assets/images/clips-banner.jpg`,
  },
];
export const galleryPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'ImageGallery',
  name: `Gallery - ${CompanyName}`,
  url: `${FULL_BUSINESS_URL}/gallery`,
  description: `Explore the gallery of ${CompanyName} featuring high-quality images from sessions and events.`,
  image: [
    `${FULL_BUSINESS_URL}/images/gallery1.jpg`,
    `${FULL_BUSINESS_URL}/images/gallery2.jpg`,
    `${FULL_BUSINESS_URL}/images/gallery3.jpg`,
  ],
  author: {
    '@type': 'Person',
    name: CompanyName,
  },
};

export const galleryPageAdditionalMeta = [
  { property: 'og:title', content: `Gallery - ${CompanyName}` },
  {
    property: 'og:description',
    content: `View the latest gallery images of ${CompanyName}.`,
  },
  {
    property: 'og:image',
    content: `${FULL_BUSINESS_URL}/images/gallery-cover.jpg`,
  },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/gallery` },
  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: `Gallery - ${CompanyName}` },
  {
    name: 'twitter:description',
    content: `Explore the latest visuals from ${CompanyName}.`,
  },
  {
    name: 'twitter:image',
    content: `${FULL_BUSINESS_URL}/images/gallery-cover.jpg`,
  },
];


export const linksPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: `Official Links - ${CompanyName}`,
  url: `${FULL_BUSINESS_URL}/links`,
  description: `Find all of ${CompanyName}’s verified profiles and premium content platforms in one place. Connect securely through her official links.`,
  author: {
    '@type': 'Person',
    name: CompanyName,
  },
};

export const linksPageAdditionalMeta = [
  {
    property: 'og:title',
    content: `Official Links - ${CompanyName}`,
  },
  {
    property: 'og:description',
    content: `Find all of ${CompanyName}’s verified profiles and premium content platforms in one place. Connect securely through her official links.`,
  },
  {
    property: 'og:image',
    content: `${FULL_BUSINESS_URL}/images/links-page-cover.jpg`,
  },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/links` },
  { name: 'twitter:card', content: 'summary_large_image' },
  {
    name: 'twitter:title',
    content: `Official Links - ${CompanyName}`,
  },
  {
    name: 'twitter:description',
    content: `Connect with ${CompanyName} through her verified profiles and premium content platforms.`,
  },
  {
    name: 'twitter:image',
    content: `${FULL_BUSINESS_URL}/images/links-page-cover.jpg`,
  },
];


// Maintenance
export const maintenancePageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Maintenance Page',
  description: `The ${CompanyName} website is currently undergoing maintenance. We’ll be back soon!`,
  url: `${FULL_BUSINESS_URL}/maintenance`,
};

export const maintenancePageAdditionalMeta = [
  { property: 'og:title', content: `We'll Be Back Soon - ${CompanyName}` },
  {
    property: 'og:description',
    content: `The ${CompanyName} website is currently undergoing maintenance. We’ll be back shortly with exciting updates.`,
  },
  {
    property: 'og:image',
    content: `${FULL_BUSINESS_URL}/assets/images/pages/maintenance-preview.jpg`,
  },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/maintenance` },
  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: `We'll Be Back Soon - ${CompanyName}` },
  {
    name: 'twitter:description',
    content: `The ${CompanyName} website is currently undergoing maintenance. We’ll be back shortly with exciting updates.`,
  },
  {
    name: 'twitter:image',
    content: `${FULL_BUSINESS_URL}/assets/images/pages/maintenance-preview.jpg`,
  },
];

// Policies page
export const termsAndPoliciesStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Terms and Policies',
  description: `Explore the terms of service and privacy policies of ${CompanyName}.`,
  url: `${FULL_BUSINESS_URL}/terms-and-policies`,
  mainEntity: {
    '@type': 'FAQPage',
    name: 'Terms and Policies FAQ',
    description: `Frequently asked questions about terms of service, privacy policies, and compliance at ${CompanyName}.`,
  },
};

export const termsAndPoliciesAdditionalMeta = [
  { property: 'og:title', content: `Terms and Policies - ${CompanyName}` },
  {
    property: 'og:description',
    content: `Understand the terms of service, privacy policies, and compliance guidelines of ${CompanyName}.`,
  },
  {
    property: 'og:image',
    content: `${FULL_BUSINESS_URL}/assets/images/pages/terms-preview.jpg`,
  },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/terms-and-policies` },
  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: `Terms and Policies - ${CompanyName}` },
  {
    name: 'twitter:description',
    content: `Learn more about our terms of service, privacy policies, and compliance at ${CompanyName}.`,
  },
  {
    name: 'twitter:image',
    content: `${FULL_BUSINESS_URL}/assets/images/pages/terms-preview.jpg`,
  },
];

// Error page
export const errorPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: '404 Error Page',
  description: `The requested page could not be found on ${CompanyName}.`,
  url: `${FULL_BUSINESS_URL}/404`,
  potentialAction: {
    '@type': 'SearchAction',
    target: `${FULL_BUSINESS_URL}/?s={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
};

export const errorPageAdditionalMeta = [
  { property: 'og:title', content: 'Page Not Found - 404' },
  {
    property: 'og:description',
    content: `Oops! The page you’re looking for isn’t here. Visit ${CompanyName} to find what you need.`,
  },
  {
    property: 'og:image',
    content: `${FULL_BUSINESS_URL}/assets/images/pages/404-preview.jpg`,
  },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/404` },
  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: 'Page Not Found - 404' },
  {
    name: 'twitter:description',
    content: `Oops! The page you’re looking for isn’t here. Visit ${CompanyName} to find what you need.`,
  },
  {
    name: 'twitter:image',
    content: `${FULL_BUSINESS_URL}/assets/images/pages/404-preview.jpg`,
  },
];


export const contactPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'ContactPage',
  mainEntity: {
    '@type': 'Person',
    name: CompanyName,
    url: FULL_BUSINESS_URL,
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'Customer Service',
      areaServed: 'GB',
      availableLanguage: ['English'],
    },
    logo: {
      '@type': 'ImageObject',
      url: `${FULL_BUSINESS_URL}/brand/logo.png`,
    },
  },
};

export const contactPageAdditionalMeta = [
  { property: 'og:title', content: `Contact ${CompanyName}` },
  {
    property: 'og:description',
    content: `Reach out to ${CompanyName} for inquiries, bookings, or any questions you may have.`,
  },
  {
    property: 'og:image',
    content: `${FULL_BUSINESS_URL}/brand/contact-preview.jpg`,
  },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/contact` },
  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: `Contact ${CompanyName}` },
  {
    name: 'twitter:description',
    content: `Get in touch with ${CompanyName} for bookings, sessions, and general inquiries.`,
  },
  {
    name: 'twitter:image',
    content: `${FULL_BUSINESS_URL}/brand/contact-preview.jpg`,
  },
];
